export default __webpack_public_path__ + "static/media/solucao-08.a7699f0b.webp";